import React from "react";
import { connect } from "react-redux";
import ShowVat from "../Components/ShowVat";

const ShowVatContainer = props => <ShowVat {...props} />;

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowVatContainer);